export default "__VITE_ASSET__DPILWzqq__"